export default __webpack_public_path__ + "static/media/ic_moldova.883409c9.svg";